




































































































































































































































/* eslint-disable max-depth */
import { FFormStep, FRadioGroup, FRadioGroupField, FMessageBox, FIcon } from '@fkui/vue';
import Vue from 'vue';
import { ValidationService, ValidatorName } from '@fkui/logic';
import { EventBus } from '@/services/MainService/event-bus';
import DataArrayItem from './DataArrayItem';
import BtNumberField from './BtNumberField.vue';
import FkRichtext from 'fk-vue-richtext';

export default Vue.extend({
    name: 'BtBarnInneboende',
    components: {
        FRadioGroup,
        FRadioGroupField,
        FMessageBox,
        FFormStep,
        FIcon,
        BtNumberField,
        FkRichtext,
    },
    props: {
        // eslint-disable-next-line vue/require-prop-types
        dataArray: {
            default: () => {
                return [] as string[];
            },
        },
    },
    data() {
        return {
            test: 'none',
            samboSelection: true,
            radioBarnSelection: '',
            radioDelarSelection: '',
            childrenUnder: '',
            childrenOver: '',
            parents: '',
            siblingsUnder: '',
            siblingsOver: '',
            anotherPerson: undefined,
            validation: {
                minValue: { minValue: 0 },
                maxValue: { maxValue: 99 },
            },
        };
    },
    watch: {
        anotherPerson: function () {
            this.onSubmitStep();
            this.toggleErrorMessages();
        },
    },
    created() {
        ValidationService.registerValidator({
            name: 'atleastoneother' as ValidatorName,
            validation: () => {
                return parseInt(this.parents || '0', 10) + parseInt(this.siblingsUnder || '0', 10) + parseInt(this.siblingsOver || '0', 10) > 0;
            },
        });
        ValidationService.registerValidator({
            name: 'atleastonechild' as ValidatorName,
            validation: () => {
                return parseInt(this.childrenUnder || '0', 10) + parseInt(this.childrenOver || '0', 10) > 0;
            },
        });
        ValidationService.registerValidator({
            name: 'annanperson' as ValidatorName,
            validation: () => {
                this.toggleErrorMessages();
                return !this.anotherPerson;
            },
        });
    },
    mounted() {
        EventBus.$on('sambo-radio', this.samboClickHandler);
    },
    destroyed() {
        EventBus.$off('sambo-radio', this.samboClickHandler);
    },
    methods: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        openContainer(toggleIsOpen: any): void {
            this.$emit('on-change-emit-hushallet');
            toggleIsOpen();
        },
        samboClickHandler(selection: boolean): void {
            this.samboSelection = selection;
            this.onSubmitStep();
        },
        onChange() {
            ValidationService.validateAllElements('btBarnInneboende');
            this.onSubmit();
            this.toggleErrorMessages();
            this.$emit('on-change-emit-hushallet');
        },
        toggleErrorMessages(): void {
            const interval = setInterval(() => {
                const errorList = this.$el.querySelector('.error-list') as HTMLElement;
                const errorIcon = this.$el.querySelector('#radio-annan .label__message--error') as HTMLElement;
                if (errorList || errorIcon) {
                    clearInterval(interval);
                    if (this.anotherPerson) {
                        if (errorList) errorList.style.display = 'none';
                        if (errorIcon) errorIcon.style.display = 'none';
                    } else {
                        if (errorList) errorList.style.display = 'block';
                        if (errorIcon) errorIcon.style.display = 'block';
                    }
                } else if (!this.anotherPerson) {
                    clearInterval(interval);
                }
            }, 100);
        },
        onChildrenInputChange(): void {
            this.onChange();
            ValidationService.validateElement('children-under');
            ValidationService.validateElement('children-over');
        },
        onOtherInputChange(): void {
            this.onChange();
            ValidationService.validateElement('parents');
            ValidationService.validateElement('siblings-under');
            ValidationService.validateElement('siblings-over');
        },
        onSubmit(): void {
            ValidationService.validateAllElements('btBarnInneboende');
            this.$nextTick(this.toggleErrorMessages);
            this.onSubmitStep();
        },
        onSubmitStepRadioBarn(dataArray: DataArrayItem[]) {
            if (this.radioBarnSelection === 'radio-barn-ja') {
                dataArray.push(
                    {
                        label: this.samboSelection
                            ? this.$t('btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende')
                            : this.$t('btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.sammanboende'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende',
                        value: 'Ja',
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omhushallet.etikett.antalbarnunder20ar'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.antalbarnunder20ar',
                        value: this.childrenUnder,
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omhushallet.etikett.antalbarnover20ar'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.antalbarnover20ar',
                        value: this.childrenOver,
                    },
                );
            } else if (this.radioBarnSelection === 'radio-barn-nej') {
                dataArray.push({
                    label: this.samboSelection
                        ? this.$t('btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende')
                        : this.$t('btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.sammanboende'),
                    itemId: 'btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende',
                    value: 'Nej',
                });
            }

            return dataArray;
        },
        onSubmitStepRadioDelar(dataArray: DataArrayItem[]) {
            if (this.radioDelarSelection === 'radio-delar-ja') {
                dataArray.push(
                    {
                        label: this.samboSelection
                            ? this.$t('btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon.ensamboende')
                            : this.$t('btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon.sammanboende'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon',
                        value: 'Ja',
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omhushallet.etikett.antalforaldrar'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.antalforaldrar',
                        value: this.parents,
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omhushallet.etikett.antalsyskonunder20'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.antalsyskonunder20',
                        value: this.siblingsUnder,
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omhushallet.etikett.antalsyskonover20'),
                        itemId: 'btp.preliminar.berakning.omhushallet.etikett.antalsyskonover20',
                        value: this.siblingsOver,
                    },
                );
            } else if (this.radioDelarSelection === 'radio-delar-nej') {
                dataArray.push({
                    label: this.samboSelection
                        ? this.$t('btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon.ensamboende')
                        : this.$t('btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon.sammanboende'),
                    itemId: 'btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon',
                    value: 'Nej',
                });
            }

            return dataArray;
        },
        onSubmitStepRadioAnnan(dataArray: DataArrayItem[]) {
            if (this.anotherPerson === true) {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.omhushallet.etikett.bordetandrapersoner'),
                    itemId: 'btp.preliminar.berakning.omhushallet.etikett.bordetandrapersoner',
                    value: 'Ja',
                });
            } else if (this.anotherPerson === false) {
                dataArray.push({
                    label: this.$t('btp.preliminar.berakning.omhushallet.etikett.bordetandrapersoner'),
                    itemId: 'btp.preliminar.berakning.omhushallet.etikett.bordetandrapersoner',
                    value: 'Nej',
                });
            }
            return dataArray;
        },
        onSubmitStep() {
            let dataArray: DataArrayItem[] = [];
            dataArray = this.onSubmitStepRadioBarn(dataArray);
            dataArray = this.onSubmitStepRadioDelar(dataArray);
            dataArray = this.onSubmitStepRadioAnnan(dataArray);
            if (!this.anotherPerson) {
                this.$root.$emit('on-submit-emit-hushallet', dataArray, 'btBarnInneboende');
                this.$emit('on-submit-emit-hushallet', dataArray, 'btBarnInneboende');
            }
        },
    },
});
